const InformationGuide = () => {
  const specialCharacters = "(| ~ \\ ^ ` : ; < = > ? @ ! \" # $ % & ' ( ) * + , . { } [ ] _ - /).";

  return (
    <>
      <section id="guia-informacoes" className="content-section">
        <div className="card mb-3">
          <div className="card-body text-center">
            <h5 className="card-title">Interface e informações gerais</h5>
          </div>
          <div className="card-body">
            <div className="card">
              <div className="card-body">
                <p className="justified-text">
                  Ao acessar o equipamento, a tela de Dashboard é apresentada:
                </p>
                <div className="d-flex justify-content-center print-image img-container">
                  <img src="./res/figures/status-geral.png" className="card-img-bottom img-lg img-xl" alt="" />
                </div>
                <ul className="p-xss-0 p-md-3 justified-text">
                  <p className="mb-0 justified-text">
                    <strong>Menu lateral</strong>
                  </p>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Dashboard:</strong> Permite acessar o dashboard do equipamento.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Rede:</strong> Permite alterar o modo de operação e o configurar o comportamento da rede
                      do equipamento
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Wireless:</strong> Permite gerenciar as redes wireless criadas pelo equipamento e o
                      comportamento delas. Também permite consultar redes Wi-Fi próximas e autenticação de servidor
                      radius
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Sistema:</strong> Permite acessar configurações de sistema do equipamento, aplicar reset
                      ao padrão de fábrica, realizar uma atualização, entre outras.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Serviços:</strong> Permite configurar os serviços disponíveis no equipamento, como
                      Splash Page, Discovery, DDNS, etc.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Segurança:</strong> Permite configurar o funcionamento das medidas de segurança do
                      firewall do equipamento.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Conexões:</strong> Permite verificar informações sobre os clientes conectados nas
                      interfaces do equipamento.
                    </p>
                  </li>
                </ul>
                <ul className="p-xss-0 p-md-3 justified-text">
                  <p className="mb-0 justified-text">
                    <strong>Menu suspenso</strong>
                  </p>
                  <p className="justified-text">
                    Ao clicar no botão <i className="fa fa-gear"></i> no canto superior direito, o menu suspenso será
                    exibido:
                  </p>
                </ul>
                <div className="d-flex justify-content-center print-image img-container">
                  <img src="./res/figures/menu-suspenso.png" className="card-img-bottom img-xs" id="menu-suspenso" alt="" style={{ marginRight: '5rem' }} />

                  <img src="./res/figures/menu-suspenso-aplicar.png" className="card-img-bottom img-xs"
                    id="menu-suspenso-aplicar" alt="" />
                </div>
                <ul className="p-xss-0 p-md-3 justified-text">
                  <p className="mb-0">
                    <strong>Obs.:</strong> O menu suspenso com "Aplicar alteração" e "Descartar alteração" somente são
                    apresentados ao ter alterações salvas pendentes.
                  </p>
                </ul>
                <p className="justified-text">
                  A partir dele é possível ter acesso à escolha de idioma, alteração de senha,
                  informações legais e gerais, bem como aplicar/descartar as alterações, reiniciar o equipamento ou
                  finalizar a
                  sessão.
                </p>
                <p className="mb-0">
                  <strong>Senha:</strong>
                </p>
                <p className="mb-0 justified-text">
                  Use essa funcionalidade para trocar a senha de administração de tempos em
                  tempos.
                </p>
                <br />
                <div className="d-flex justify-content-center print-image img-container">
                  <img src="./res/figures/alterar-senha.png" className="card-img-bottom img-xl" alt="" />
                </div>
                <br />
                <ul className="p-xss-0 p-md-3 justified-text">
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Senha atual:</strong> digite a senha atual de administração.
                    </p>
                  </li>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>Nova senha:</strong> digite a nova senha de administração.
                    </p>
                  </li>
                  <ul>
                    <li>
                      <p className="mb-0">Mínimo 8 caracteres e máximo de 63 caracteres;</p>
                    </li>
                    <li>
                      <p className="mb-0">Pelo menos 1 (um) número;</p>
                    </li>
                    <li>
                      <p className="mb-0">Pelo menos 1 (uma) letra maiúscula;</p>
                    </li>
                    <li>
                      <p className="mb-0">Pelo menos 1 (uma) letra minúscula;</p>
                    </li>
                    <li>
                    Pelo menos 1 (um) caractere especial dentre os seguintes ${specialCharacters}

                    </li>

                  </ul>
                  <li>
                    <p className="mb-0 justified-text">
                      <strong>
                        Confirmar nova senha:
                      </strong>
                      digite novamente a nova senha de
                      administração.
                    </p>
                  </li>
                </ul>
                <p className="mb-0">
                  <strong>
                    Aplicar ou descartar alterações:
                  </strong>
                </p>
                <p className="justified-text">
                  Ao clicar em Aplicar ou Descartar Alterações, será solicitada confirmação adicional como nas imagens
                  abaixo:
                </p>
                <div className="d-flex justify-content-center print-image img-container">
                  <img src="./res/figures/aplicar-alteracoes-menu.png" className="card-img-bottom img-xs" alt="" />
                </div>
                <ul className="p-xss-0 p-md-3 justified-text">
                  <p className="mb-0">
                    <strong>
                      Obs.:
                    </strong>
                    Ao clicar em "Confirmar alteração", o equipamento irá reiniciar com as
                    últimas
                    configurações salvas.
                  </p>
                </ul>
                <div className="d-flex justify-content-center print-image img-container">
                  <img src="./res/figures/aplicar-alteracoes.png" className="card-img-bottom img-lg" alt="" />
                </div>
                <p className="text-center">
                  ou
                </p>
                <div className="d-flex justify-content-center print-image img-container">
                  <img src="./res/figures/descartar-alteracoes.png" className="card-img-bottom img-lg" alt="" />
                </div>
                <p className="mb-0">
                  <strong>
                    Reiniciar Equipamento:
                  </strong>
                </p>
                <p className="justified-text">
                  Permite ao administrador realizar reboot do equipamento.
                </p>
                <div className="d-flex justify-content-center print-image img-container">
                  <img src="./res/figures/reiniciar.png" className="card-img-bottom img-lg" alt="" />
                </div>
                <br />
                <p className="mb-0">
                  <strong>
                    Informações Legais:
                  </strong>
                </p>
                <p className="justified-text">
                  É possível visualizar a Política e Privacidade e os
                  Termos de uso.
                </p>
                <p className="mb-0">
                  <strong>
                    Política e Privacidade
                  </strong>
                </p>
                <div className="d-flex justify-content-center print-image img-container">
                  <img src="./res/figures/privacidade.png" className="card-img-bottom img-lg img-xl" alt="" />
                </div>
                <br />
                <p className="mb-0">
                  <strong>
                    Termos de uso:
                  </strong>
                </p>
                <div className="d-flex justify-content-center print-image img-container">
                  <img src="./res/figures/termo-uso.png" className="card-img-bottom img-lg img-xl" alt="" />
                </div>
                <p className="mb-0">
                  <strong>
                    Informações Gerais:
                  </strong>
                </p>
                <p className="mb-0 justified-text">
                  Também é possível pelo menu suspenso ter acesso às informações gerais do sistema.
                </p>
                <br />
                <div className="d-flex justify-content-center print-image img-container">
                  <img src="./res/figures/info-gerais.png" className="card-img-bottom img-lg img-xl" id="infos-gerais"
                    alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default InformationGuide;
